import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectRole } from '../../../../../routing/fetchingfunction/user/user.reducer'
import { getMyBannersTabs, hideMyBannersContentRoutes } from '../../../../../constants'

const MyBanners = () => {
  const location = useLocation()
  const role = useSelector(selectRole)

  // Determine if only nested content should render (e.g., subroute view)
  const isContentHidden = hideMyBannersContentRoutes.some((route) =>
    location.pathname.includes(route)
  )

  // Get tabs based on role
  const myBannersTabs = getMyBannersTabs(role) || []

  return (
    <div className="w-full pb-16">
      {isContentHidden ? (
        <Outlet />
      ) : (
        <>
          <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-5 text-primary-100">
            Banners Settings
          </h3>

          <div className="w-full mt-5 bg-[#FEEBDD] rounded-[10px] p-8">
            {/* Tabs */}
            <div className="w-full flex items-center gap-x-8 mb-5">
              {myBannersTabs.map(({ link, label, exact }) => {
                const isActive = exact
                  ? location.pathname === link
                  : location.pathname.includes(link)

                return (
                  <Link
                    key={link}
                    to={link}
                    className={`relative text-2xl font-bold pb-4 text-primary-100 hover:text-primary-100 transition-opacity duration-200 ease-in-out
                      after:absolute after:bottom-0 after:left-0 after:w-full after:h-1 
                      ${isActive ? 'opacity-100 after:bg-primary-100' : 'opacity-70 after:bg-transparent'}
                    `}
                  >
                    {label}
                  </Link>
                )
              })}
            </div>

            {/* Nested route content */}
            <Outlet />
          </div>
        </>
      )}
    </div>
  )
}

export default MyBanners
